import {Component, OnInit, ViewChild} from '@angular/core';
import {Events, Platform, Nav, Alert, AlertController, ToastController, IonicApp, MenuController} from 'ionic-angular';
//import {AppVersion} from "ionic-native";

import {LoginPage} from "../pages/login/login";
import {ConfigService, GetNewsService, MenuProvider, NewsService, SharedService, StorageService} from "../providers";
//import {LoaderPage} from "../pages/loader/loader";
import {FeedPage} from "../pages/feed/feed";
import {KeywordsListPage} from "../pages/keywords-list/keywords-list";
import {SettingsPage} from "../pages/settings/settings";
//import {TweetsKeywords} from "../pages/tweets-keywords/tweets-keywords";
import {TwitterLogin} from "../pages/twitter-login/twitter-login";
//import {TweetsFollowings} from "../pages/tweets-followings/tweets-followings";
import {Tweets} from "../pages/tweets/tweets";
import {TwitterSettings} from "../pages/twitter-settings/twitter-settings";

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  @ViewChild(Nav) nav: Nav;
  rootPage = LoginPage;
  public menuLogo = "./assets/images/logo_DS.png"; // TODO change
  public showMenu: boolean = false;
  public sourceMenu: any;
  public showSources = false;
  public showSocial = false;
  private alert: Alert;
  public appVersion: string;

  constructor(
    private platform: Platform,
    public menuProvider: MenuProvider,
    public events: Events,
    public getNewsService: GetNewsService,
    private newsService: NewsService,
    private storageService: StorageService,
    //private sharedService: SharedService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private ionicApp: IonicApp,
    private menuCtrl: MenuController,
    private cnf: ConfigService
  ) {
    this.appVersion = this.cnf.appVersion;
    platform.ready().then(() => {
      platform.registerBackButtonAction(() => {
        let activePortal = this.ionicApp._loadingPortal.getActive() ||
          this.ionicApp._modalPortal.getActive() ||
          this.ionicApp._toastPortal.getActive() ||
          this.ionicApp._overlayPortal.getActive();

        //activePortal is the active overlay like a modal,toast,etc
        if (activePortal) {
          activePortal.dismiss();
          return
        }

        let view = this.nav.getActive(); // As none of the above have occurred, its either a page pushed from menu or tab
        let activeVC = this.nav.getActive(); //get the active view

        let page = activeVC.instance; //page is the current view's instance i.e the current component I suppose


        if (this.nav.canGoBack() || view && view.isOverlay) {
          this.nav.pop(); //pop if page can go back or if its an overlay over a menu page
        }
        else {
          this.showAlert();
        }

        return;


      });
    });
  }

  ngOnInit() {
    // TODO: auto login se i dati sono validi
    // avvio a freddo
    this.storageService.reloadStorage();
    this.storageService.set('warm', false);
    this.events.subscribe('login:ok', () => {
      this.getNewsService.getMenu()
        .subscribe((data: any) => {
          this.showMenu = true;
          this.sourceMenu = this.buildMenu(data);
          //console.log(this.sourceMenu);
          this.menuCtrl.open();
        }, (err) => {
          //console.error('err');
        });
    });
  }

  private buildMenu(data: any): any[] {
    let sourceMenu = [];
    if (!data || !data.menu || !data.menu.children) { return null; }
    sourceMenu = this.buildSubMenu(data.menu.children);
    return sourceMenu;
  }

  private buildSubMenu(data: any[]) {
    const subMenu = [];
    for (const s of data) {
      if (s && s.name) {
        let children = [];
        if (s.children) {
          children = this.buildSubMenu(s.children);
        }
        subMenu.push({
          name: s.name,
          displayName: this.formatTitle(s.name),
          children: children,
          expand: false,
        });
      }
    }
    return subMenu;
  }

  private formatTitle(title: string) {
    if (!title) {
      return '';
    }
    return title.split('\\').pop();
  }

  public openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // console.log('openPage');

    if (page === '') {
      this.nav.setRoot(FeedPage)
        .catch(err => console.log(err));
    } else {
      this.nav.setRoot(FeedPage, {fromMenu: page.name})
        .catch(err => console.log(err));
    }
  }

  openCustomPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page === 'keywords') {
      this.nav.setRoot(KeywordsListPage)
        .catch(err => console.log(err));
    } else if (page === 'settings') {
      this.nav.setRoot(SettingsPage)
        .catch(err => console.log(err));
    }
  }

  showSourcesMenu() {
    this.showSources = !this.showSources;
  }

  hasSubmenu(p: any) {
    if (!p) {
      return false;
    }
    return p.children !== null;
  }

  logout() {
    this.storageService.set('autologin', false);
    this.newsService.reset();
    this.getNewsService.logout()
      .subscribe((data) => {
          this.showMenu = false;
          this.nav.setRoot(LoginPage)
            .catch(err => console.log(err));
        }
      );
  }

  exit() {
    this.platform.exitApp();
  }

  showSocialMenu() {
    this.showSocial = !this.showSocial;
  }

  goTo(page) {
    switch (page) {
      case 'TwitterSettings':
        this.nav.setRoot(TwitterSettings)
          .catch(err => console.log(err));
        break;
      case 'Tweets':
        this.nav.setRoot(Tweets)
          .catch(err => console.log(err));
        break;

      case 'TweetsFollowing':
        this.nav.setRoot(Tweets, {type: 'followings'})
          .catch(err => console.log(err));
        break;

      case 'TweetsKeywords':
        this.nav.setRoot(Tweets, {type: 'keywords'})
          .catch(err => console.log(err));
        break;

      case 'TwitterLogin':
        this.nav.setRoot(TwitterLogin)
          .catch(err => console.log(err));
        break;
    }

  }

  showAlert() {
    this.alert = this.alertCtrl.create({
      title: 'Uscire?',
      message: 'Vuoi chiudere l\'app?',
      buttons: [
        {
          text: 'Annulla',
          role: 'cancel',
          handler: () => {
            this.alert = null;
          }
        },
        {
          text: 'Esci',
          handler: () => {
            this.platform.exitApp();
          }
        }
      ]
    });
    this.alert.present();
  }

  showToast() {
    let toast = this.toastCtrl.create({
      message: 'Press Again to exit',
      duration: 2000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      // console.log('Dismissed toast');
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts